module.exports = __webpack_public_path__ + "static/media/jQuery-color.c8bdf242.png";